import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { getInitialLetter } from "@/utils";
const UserAvatar = (props) => {
    var _a;
    const { candidateName = "", type, width, height, onClick, src, isAppliedAgency, color, backgroundColor, size, AnonymousUser, AnonymousUserColor, avatarBackground = "#EBEDFA", cursor = "default", } = props;
    const name = candidateName ? (_a = candidateName === null || candidateName === void 0 ? void 0 : candidateName.toString()) === null || _a === void 0 ? void 0 : _a.toUpperCase() : "";
    return (_jsxs(_Fragment, { children: [type === "profileAvatar" ? (_jsx(Stack, { direction: "row", spacing: 2, children: _jsx(Avatar, { onClick: onClick, sx: {
                        width: width ? width : 50,
                        marginLeft: 0,
                        height: height ? height : 50,
                        backgroundColor: backgroundColor ? backgroundColor : isAppliedAgency ? "#E8EBF9" : "#ffff",
                        color: AnonymousUser ? AnonymousUserColor : color ? color : "#111A45",
                        borderRadius: "50px",
                    }, src: src, children: AnonymousUser ? null : getInitialLetter(name) }) })) : (""), type === "headerAvatar" ? (_jsx(Stack, { direction: "row", spacing: 2, children: _jsx(Avatar, { onClick: onClick, sx: { width: 43, height: 43, backgroundColor: "#EBEDFA", color: "#111A45", top: "-4px", right: "4px" }, children: getInitialLetter(name) }) })) : (""), type === "avtarStyle" ? (_jsx(Stack, { direction: "row", spacing: 2, children: _jsx(Avatar, { onClick: onClick, src: src ? src : "", sx: {
                        width: width,
                        height: height,
                        backgroundColor: avatarBackground,
                        color: "#111A45",
                        cursor: cursor,
                    }, children: getInitialLetter(name) }) })) : ("")] }));
};
export default UserAvatar;
